/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import { FireBellyBackground } from '../images';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

export const BrandBackgroundDefault = () : JSX.Element => (
    <div className={ 'absolute inset-0 -z-10' }>
        <div
            className={
                clsx(
                    'absolute blur-sm inset-0 brightness-[.83]',
                    'w-screen bg-no-repeat bg-cover bg-center'
                )
            }
            style={ { backgroundImage: `url(${ FireBellyBackground })` } }
        />
    </div>
);
